import { useMemo } from 'react';

interface UseChatInputValidationOptions {
	prompt: string;
	loadingAttachments: any[] | undefined;
}

interface UseChatInputValidationResult {
	canSubmit: boolean;
	hasLoadingAttachments: boolean;
	minimalInputEntered: boolean;
}

export function useChatInputValidation({
	prompt,
	loadingAttachments,
}: UseChatInputValidationOptions): UseChatInputValidationResult {
	const hasLoadingAttachments = useMemo(
		() => !!(loadingAttachments && loadingAttachments.length > 0),
		[loadingAttachments]
	);

	const minimalInputEntered = useMemo(() => prompt.trim().length > 0, [prompt]);

	const canSubmit = minimalInputEntered && !hasLoadingAttachments;

	return {
		canSubmit,
		hasLoadingAttachments,
		minimalInputEntered,
	};
}
